import { render, staticRenderFns } from "./WeblogDetails.vue?vue&type=template&id=33e6a72e&scoped=true"
import script from "./WeblogDetails.vue?vue&type=script&lang=js"
export * from "./WeblogDetails.vue?vue&type=script&lang=js"
import style0 from "./WeblogDetails.vue?vue&type=style&index=0&id=33e6a72e&prod&scoped=true&lang=css"
import style1 from "./WeblogDetails.vue?vue&type=style&index=1&id=33e6a72e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e6a72e",
  null
  
)

export default component.exports